import * as React from 'react';
import { st, classes } from './ColorPickerItem.st.css';
import { CoreRadioButton as RadioButton } from '../../internal/WixUiCoreComponents/components/CoreRadioButton';
import { TPAComponentsContext, } from '../../TPAComponentsConfig';
import { TOOLTIP_COMMON_PROPS } from './tooltipCommonProps';
import { MobileTooltip } from './MobileTooltip';
import { Tooltip } from '../../Tooltip';
import { DATA_HOOKS } from '../dataHooks';
export class ColorPickerItem extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { focused: false, focusedByKeyboard: false };
        this._onHover = () => {
            this.setState({ focused: true });
        };
        this._onIconBlur = () => {
            this.setState({ focused: false });
        };
        this._onFocusByKeyboard = () => {
            this.setState({ focusedByKeyboard: true });
        };
        this._onBlur = () => {
            this.setState({ focusedByKeyboard: false });
        };
        this._getColorDotContent = () => {
            const { value } = this.props;
            return (React.createElement("div", { className: classes.radioOuter },
                React.createElement("div", { className: classes.radioInner, style: { backgroundColor: value } })));
        };
    }
    _getTooltipProps() {
        const { mobile } = this.context;
        const { tooltip, tooltipDataHook } = this.props;
        return mobile
            ? { tooltip }
            : {
                content: tooltip,
                'data-hook': tooltipDataHook,
                ...TOOLTIP_COMMON_PROPS,
            };
    }
    _getColorDot() {
        const { mobile } = this.context;
        const { tooltip } = this.props;
        let colorDot = this._getColorDotContent();
        if (tooltip) {
            const TooltipType = (mobile ? MobileTooltip : Tooltip);
            const tooltipProps = this._getTooltipProps();
            colorDot = React.createElement(TooltipType, { ...tooltipProps }, colorDot);
        }
        return colorDot;
    }
    render() {
        const { focused, focusedByKeyboard } = this.state;
        const { className, checked, 'aria-label': ariaLabel, tooltipDataHook, disabled, value, onChange, name, isCrossedOut, required, unstableHasInnerWrapper, } = this.props;
        const colorDot = this._getColorDot();
        return (React.createElement(RadioButton, { className: st(classes.root, {
                checked,
                focused,
                focusedByKeyboard,
                unavailable: isCrossedOut,
            }, className), [DATA_HOOKS.colorPickerItemDataCrossed]: isCrossedOut,
            [DATA_HOOKS.colorPickerItemChecked]: checked && !disabled, "aria-label": ariaLabel, "data-hook": DATA_HOOKS.colorPickerItem, "data-tooltip-hook": tooltipDataHook, disabled: disabled, checked: checked && !disabled, checkedIcon: colorDot, value: value, uncheckedIcon: colorDot, onChange: onChange, name: name, onHover: this._onHover, onIconBlur: this._onIconBlur, onFocusByKeyboard: this._onFocusByKeyboard, onBlur: this._onBlur, required: required, unstableHasInnerWrapper: unstableHasInnerWrapper }));
    }
}
ColorPickerItem.displayName = 'ColorPickerItem';
ColorPickerItem.defaultProps = {
    tooltipDataHook: DATA_HOOKS.colorPickerItemTooltip,
};
ColorPickerItem.contextType = TPAComponentsContext;
//# sourceMappingURL=ColorPickerItem.js.map